(function($) {
  // Site title
  $('.single-bike .slider').slick({
    // centerMode: true,
    // slidesToShow: 1,
    // centerPadding: '10px',
    // autoplay: true,
    // autoplaySpeed: 2000,
    // variableWidth: true,
    arrows: true,
    // prevArrow: '.slider-prev',
    // nextArrow: '.slider-next',
    responsive: [
    {
      breakpoint: 787,
      settings: {
        variableWidth: false,
        centerPadding: 0,
        asNavFor: '.single-bike .slider-thumbnail',
        dots: false,
        //arrows: false
      }
    }]
  });

  $('.single-bike .slider-thumbnail').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.single-bike .slider',
    centerMode: true,
    centerPadding: '30px',
    focusOnSelect: true,
    arrows: false
  });

  $('.single-bike .thumbnail-area > div > a[data-index="0"]').addClass('active');
  $('.single-bike .slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    $('.single-bike .thumbnail-area > div > a').removeClass('active');
    $('.single-bike .thumbnail-area > div > a[data-index="' + nextSlide + '"]').addClass('active');
  });

  $('.single-bike .thumbnail-area > div > a').click(function(event){
    //$('.single-bike .thumbnail-area > div > a').removeClass('active');
    $('.single-bike .slider').slick('slickGoTo', $(this).data('index'));
    //$(this).addClass('active');
    event.preventDefault();
  });

  $('.search-box-button').click(function(){
    $('.search-box').slideToggle();
    $(this).toggleClass('close-btn');
  });

  $('.search-manufacturer input[type=checkbox]').change(function(){
    if( $(this).prop('checked') ) {
      if($(this).attr('name') === "search_manufacturer[]" && $('.search-manufacturer input[name=search_manufacturer_all]').prop('checked')) {
        $('.search-manufacturer input[name=search_manufacturer_all]').prop('checked', false).parent().removeClass('active');
      }

      if($(this).attr('name') === "search_manufacturer_all") {
        $('.search-manufacturer input[name="search_manufacturer[]"]').prop('checked', false).parent().removeClass('active');
      }

    }
  });

  $('.search-engine input[type=checkbox]').change(function(){
    if( $(this).prop('checked') ) {
      if($(this).attr('name') === "search_engine[]" && $('.search-engine input[name=search_engine_all]').prop('checked')) {
        $('.search-engine input[name=search_engine_all]').prop('checked', false).parent().removeClass('active');
      }

      if($(this).attr('name') === "search_engine_all") {
        $('.search-engine input[name="search_engine[]"]').prop('checked', false).parent().removeClass('active');
      }

    }
  });
  $('.post-type-archive-bike select.with-event').change(function(){
    var filtered = bikes_for_search;
    //console.log(filtered);
    var $selected = $('select[name=new_or_old_refine] option:selected');
    if($selected && $selected[0].value) {
      filtered = $.grep(filtered, function(elem) {
        return (elem.new_or_old === $selected[0].value);
      });
    }
    $selected = $('select[name=search_manufacturer_refine] option:selected');
    if($selected && $selected[0].value) {
      filtered = $.grep(filtered, function(elem) {
        return (elem.search_manufacturer === $selected[0].value);
      });
    }

    $selected = $('select[name=search_engine_refine] option:selected');
    if($selected && $selected[0].value) {
      filtered = $.grep(filtered, function(elem) {
        return (elem.search_engine === $selected[0].value);
      });
    }

    $selected = $('select[name=transmission_refine] option:selected');
    if($selected && $selected[0].value) {
      filtered = $.grep(filtered, function(elem) {
        return (elem.transmission === $selected[0].value);
      });
    }

    console.log(filtered);

    var search_titles = [];
    var optionItems = [];
    $.each(filtered, function(key, val){
      if(val.search_title) {
        search_titles.push(val.search_title);
      }
    });
    console.log(search_titles);

    if(search_titles.length === 0) {
      optionItems.push('<option value="">見つかりませんでした</option>');
    } else {
      search_titles = $.unique(search_titles);
      optionItems.push('<option value="">すべて</option>');

      $.each(search_titles, function(key, val){
          optionItems.push('<option value="' + search_titles[key] + '">' + search_titles[key] + '</option>');
      });
    }
    $("#search_title").empty();
    $("#search_title").append(optionItems.join());

  });

})(jQuery);
